import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const AddIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 38.045 38.045">
      <g transform="translate(-6.281 -11.12)">
        <g transform="translate(25.303 15.12) rotate(45)">
          <line
            x2="21.245"
            y2="21.245"
            transform="translate(0)"
            fill="none"
            stroke={props.color || theme.palette.gray.main}
            strokeLinecap="round"
            strokeWidth="4"
          />
          <line
            y1="21.245"
            x2="21.245"
            transform="translate(0)"
            fill="none"
            stroke={props.color || theme.palette.gray.main}
            strokeLinecap="round"
            strokeWidth="4"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
